import script from "./Photos.vue?vue&type=script&setup=true&lang=ts"
export * from "./Photos.vue?vue&type=script&setup=true&lang=ts"

export default script